import React, { useEffect, useState } from "react";

import { motion, AnimatePresence } from "framer-motion";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import { useLocation, useNavigate } from "react-router-dom";
import Footerdeo from "../shared/Footerdeo";
import { div } from "framer-motion/client";

import Swal from "sweetalert2";
import config from "../../config";
import axios from "axios";
import { Link } from "react-router-dom";
import StudentDetailsModal from "./StudentDetailsModal";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

const TotalRejectedApplicant = () => {
  const [modal, setModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const deO_ID = sessionStorage.getItem("deoid");
  // const school_code = sessionStorage.getItem("school_code");

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  const token = sessionStorage.getItem("deotoken");
  const location = useLocation();
  const navigate = useNavigate();
  const schoolCode = location.state?.schoolCode;

  const handleModalOpen = async (student) => {
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/FetchDEODemographyData_CL9`,
        {
          candidatE_ID: student.candidatE_ID,
          schooL_CODE: schoolCode,
          districtcode: sessionStorage.getItem("deoId"),
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      setSelectedStudent(response.data?.data["deoDemography_data"] || {});
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student demography data:", error);
      Swal.fire("Error", "Failed to fetch demography data", "error");
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };
  const handleViewRemarks = (remarks) => {
    setSelectedRemarks(remarks || "No remarks available.");
    setShowRejectedModal(true);
  };

  useEffect(() => {
    const fetchRejectedDetails = async () => {
      try {
        const response = await axios.post(
          `${config.API_BASE_URL}/DEORejectedCheckDetails_CL9`,
          {
            DEO_ID: sessionStorage.getItem("deoId"),
            SCHOOL_CODE: schoolCode,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data?.status === 200) {
          setStudents(response.data.data.deoRejected_status || []);
        } else {
          console.warn("No rejected data found.");
          setStudents([]);
        }
      } catch (error) {
        console.error("Error fetching rejected candidates:", error);
        setStudents([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRejectedDetails();
  }, []);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredStudents = students.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.candidatE_ID?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query)
    );
  });
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbardeo />
        <div className="container-fluid page-body-wrapper">
          <Sidebardeo />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-user"></i>&nbsp; Total Rejected
                      Applicant
                    </h1>
                    <ol className="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            navigate("/deo-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li className="active"> Total Rejected Applicant</li>
                    </ol>
                  </section>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-1">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                          <label htmlFor="rowsPerPage" className="me-2 mb-0">
                            Rows:
                          </label>
                          <select
                            id="rowsPerPage"
                            className="form-select form-select-sm"
                            value={perPage}
                            onChange={handlePerPageChange}
                            style={{ width: "80px" }}
                          >
                            {[10, 20, 50, 100, 500].map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))}
                          </select>
                        </div>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          style={{ width: "200px" }}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      <table
                        id="pendingApplicantsTable"
                        className="table table-bordered table-striped table-sm "
                      >
                        <thead className="table-light justify-center">
                          <tr>
                            {/* <th>
                              <input type="checkbox" disabled />
                            </th> */}
                            <th>Sl. No</th>
                            <th>Candidate ID</th>
                            <th>Candidate Name</th>
                            <th>Date of Birth</th>
                            <th>Father's Name</th>
                            <th>Mother's Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((student, index) => (
                              <tr key={student.candidatE_ID || index}>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td>{student.candidatE_ID}</td>
                                <td>{student.candidatE_NAME}</td>
                                <td>{student.dob.split(" ")[0]}</td>
                                <td>{student.fatheR_NAME}</td>
                                <td>{student.motheR_NAME}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-danger"
                                    style={{ fontSize: "12px" }}
                                    onClick={() =>
                                      handleViewRemarks(
                                        student.remarkS_REJECTED
                                      )
                                    }
                                  >
                                    <i className="fa fa-times"></i>&nbsp;
                                    {student.deO_STATUS}
                                  </button>
                                </td>
                                <td>
                                  <div>
                                    <button
                                      className="btn btn-primary btn-sm mb-1"
                                      onClick={() => handleModalOpen(student)}
                                    >
                                      View Details
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="8"
                                className="text-center text-muted"
                              >
                                No rejected applicants found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          Showing{" "}
                          {filteredStudents.length === 0
                            ? 0
                            : indexOfFirstItem + 1}{" "}
                          to{" "}
                          {Math.min(indexOfLastItem, filteredStudents.length)}{" "}
                          of {filteredStudents.length} entries
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <MdOutlineKeyboardDoubleArrowLeft
                            onClick={() => currentPage > 1 && setCurrentPage(1)}
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />
                          <MdOutlineKeyboardArrowLeft
                            onClick={() =>
                              currentPage > 1 &&
                              setCurrentPage((prev) => prev - 1)
                            }
                            style={{
                              cursor:
                                currentPage > 1 ? "pointer" : "not-allowed",
                              opacity: currentPage > 1 ? 1 : 0.5,
                            }}
                          />
                          <span>
                            Page {currentPage} of {totalPages}
                          </span>
                          <MdOutlineKeyboardArrowRight
                            onClick={() =>
                              currentPage < totalPages &&
                              setCurrentPage((prev) => prev + 1)
                            }
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                          <MdOutlineKeyboardDoubleArrowRight
                            onClick={() =>
                              currentPage < totalPages &&
                              setCurrentPage(totalPages)
                            }
                            style={{
                              cursor:
                                currentPage < totalPages
                                  ? "pointer"
                                  : "not-allowed",
                              opacity: currentPage < totalPages ? 1 : 0.5,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footerdeo />
          </div>
        </div>
      </div>

      {showModal && (
        <StudentDetailsModal
          show={showModal}
          handleClose={handleModalClose}
          studentData={selectedStudent}
        />
      )}

      <AnimatePresence>
        {showRejectedModal && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1050,
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="modal-content p-4 bg-white rounded"
              style={{ width: "400px", position: "relative" }}
            >
              <h5 className="mb-3">DEO Rejection Remarks</h5>
              <textarea
                className="form-control"
                rows="5"
                value={selectedRemarks}
                readOnly
              />
              <div className="text-end mt-3">
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => setShowRejectedModal(false)}
                >
                  Close
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default TotalRejectedApplicant;
